<template>
  <div class="status-wrapper" @click="onSwitchTab">
    <div class="icon">
      <img :src="icon" />
    </div>
    <div class="info">
      <div v-if="current_tab == 0">
        <slot name="first_tab"></slot>
        <!-- <h3>14 хв 15 с</h3>
        <p>До прияняття заказа</p> -->
      </div>
      <div v-else-if="current_tab == 1">
        <slot name="second_tab"></slot>
      </div>
      <div class="switcher" v-if="show_switcher">
        <div :class="current_tab == 0 ? 'tab active' : 'tab'"></div>
        <div :class="current_tab == 0 ? 'tab mt-10' : 'tab active mt-10'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show_switcher: {
      type: Boolean,
      default: false,
    },
    current_tab: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  methods: {
    onSwitchTab() {
      this.$emit("switchTab");
    },
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.status-wrapper {
  display: flex;
  padding: 1.7vh 2.5vh;
  background: #1d1d1d;
  height: 9.5vh;
  align-items: center;
  cursor: pointer;
}

.icon img {
  height: 4.6vh;
  width: 4.6vh;
}
.info {
  position: relative;
  width: 100%;
  padding-left: 1.2vh;
}
.info h3 {
  font-size: 2.8vh;
  line-height: normal;
  color: #ededed;
}
.info p {
  font-size: 1.7vh;
  color: #908f8d;
}
.switcher {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  right: 0;
  z-index: 1;
  display: flex;
  flex-flow: column;
}
.switcher .tab {
  background-color: #908f8d;
  width: 1.2vh;
  height: 1.2vh;
}
.switcher .tab.active {
  background-color: #129b81;
}
.mt-10 {
  margin-top: 1.1vh;
}
@media (min-width: 768px) {
  .icon img {
    width: 2.569vw;
    height: 2.569vw;
    margin: 0 !important;
  }
  div.status-wrapper {
    padding: 1.389vw 1.389vw;
    height: 5.347vw;
  }
  .switcher div.tab {
    width: 0.694vw;
    height: 0.694vw;
  }
  .info h3 {
    font-size: 1.597vw;
    line-height: normal;
  }
  .info p {
    font-size: 0.903vw;
  }
}
</style>
